export default [
  // {
  //   prop: "Id",
  //   label: "No",
  //   minWidth: 80,
  //   fixed: true,
  //   sortable: true,
  //   // formatter: ColorInternarRequest
  // },
  {
    prop: "Description",
    label: "Descripcion",
    minWidth: 250,
    sortable: true,
    fixed: true
    //formatter: row => `${row.corta ? row.corta.substring(0, 30) : ""}...`
  },
  {
    prop: "DaysToRespond",
    label: "Sla (dias)",
    minWidth: 80,
    sortable: true
  },
  {
    prop: "DirectionName",
    label: "Dirección",
    minWidth: 100,
    sortable: true
  },
  {
    prop: "DeparmentName",
    label: "Departamento",
    minWidth: 100,
    sortable: true
  },
  {
    prop: "ResponsableName",
    label: "Responsable",
    minWidth: 100,
    sortable: true
  },
  {
    prop: "PositionName",
    label: "Cargo Responsable",
    minWidth: 130,
    sortable: true
  }
  // {
  //   prop: "CreatedAt",
  //   label: "Fecha Creación",
  //   minWidth: 120,
  //   attrs: {
  //     onlyDate: true
  //   },
  //   // formatter: DatetimeFormatter
  // },
  // {
  //   prop: "DisplayType",
  //   label: "Tipo de Solicitud",
  //   minWidth: 250
  //   // formatter: RequestType
  // },
  // {
  //   prop: "DiasRetrasadosSla",
  //   label: "Atraso",
  //   minWidth: 120
  // },
  // {
  //   prop: "StatusSlaDescripcion",
  //   label: "Cumplimiento",
  //   minWidth: 130,
  //   // formatter: ColorInternarStatus
  // },

  // {
  //   prop: "Valoracion",
  //   label: "Calificacion",
  //   minWidth: 200,
  //   formatter: GetRate
  // },
  // {
  //   prop: "CreateBy",
  //   label: "Creado Por",
  //   minWidth: 250,
  //   // formatter: ImagePerson,
  //   attrs: {
  //     imgKey: "CreatorImage"
  //   }
  // },
  // {
  //   prop: "DisplayResponsable",
  //   label: "Responsable",
  //   minWidth: 250,
  //   // formatter: ImagePerson,
  //   attrs: {
  //     imgKey: "ResponsableImage"
  //   }
  // },
  // {
  //   prop: "Supervisor",
  //   label: "Supervisor",
  //   minWidth: 250,
  //   // formatter: ImagePerson,
  //   attrs: {
  //     imgKey: "SupervisorImage"
  //   }
  // }
  // {
  //   prop: "ComentarioValoracion",
  //   label: "Comentario Valoración",
  //   minWidth: 250
  // }
];

export const ActionsRquestsTypes = [
  // {
  //   icon: "el-icon-view",
  //   label: "Ver",
  //   command: "view-request-onLate"
  // },
  {
    icon: "el-icon-edit",
    label: "Editar",
    command: "edit-request-type"
  }
];
